import "./ToolButton.css";

interface ToolButtonProps {
  label: string;
  icon: string;
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

function Icon({ name }: { name: string }) {
  switch (name) {
    case "marker":
      return (
        <svg viewBox="0 0 64 64" width="48" height="48" aria-hidden>
          <rect
            x="23"
            y="10"
            width="18"
            height="36"
            fill="#ffd54f"
            stroke="#000"
            strokeWidth="3"
          />
          <polygon points="23,46 41,46 32,60" fill="#000" />
          <rect
            x="23"
            y="10"
            width="18"
            height="8"
            fill="#e53935"
            stroke="#000"
            strokeWidth="3"
          />
        </svg>
      );
    case "eraser":
      return (
        <svg viewBox="0 0 64 64" width="48" height="48" aria-hidden>
          <g transform="rotate(-20 32 32)">
            <rect
              x="10"
              y="22"
              width="44"
              height="22"
              fill="#ec407a"
              stroke="#000"
              strokeWidth="3"
            />
            <rect
              x="10"
              y="22"
              width="44"
              height="8"
              fill="#fce4ec"
              stroke="#000"
              strokeWidth="3"
            />
          </g>
        </svg>
      );
    case "bucket":
      return (
        <svg viewBox="0 0 64 64" width="48" height="48" aria-hidden>
          <path
            d="M14 18 L50 18 L44 58 L20 58 Z"
            fill="#90caf9"
            stroke="#000"
            strokeWidth="3"
          />
          <path
            d="M14 18 Q32 6 50 18"
            fill="none"
            stroke="#000"
            strokeWidth="3"
          />
          <path
            d="M46 18 Q58 20 58 36"
            fill="none"
            stroke="#000"
            strokeWidth="3"
          />
          <ellipse cx="58" cy="40" rx="4" ry="8" fill="#1e88e5" />
        </svg>
      );
    case "text":
      return (
        <svg viewBox="0 0 64 64" width="48" height="48" aria-hidden>
          <text
            x="32"
            y="46"
            textAnchor="middle"
            fontSize="48"
            fontWeight="900"
            fontFamily="serif"
            fill="#000"
          >
            A
          </text>
        </svg>
      );
    case "image":
      return (
        <svg viewBox="0 0 64 64" width="48" height="48" aria-hidden>
          <rect
            x="8"
            y="12"
            width="48"
            height="40"
            fill="#fff"
            stroke="#000"
            strokeWidth="3"
          />
          <circle
            cx="22"
            cy="26"
            r="5"
            fill="#fdd835"
            stroke="#000"
            strokeWidth="2"
          />
          <path
            d="M14 48 L28 34 L40 44 L50 30 L56 48 Z"
            fill="#43a047"
            stroke="#000"
            strokeWidth="2"
          />
        </svg>
      );
    case "shape":
      return (
        <svg viewBox="0 0 64 64" width="48" height="48" aria-hidden>
          <rect
            x="6"
            y="34"
            width="22"
            height="22"
            fill="#90caf9"
            stroke="#000"
            strokeWidth="3"
          />
          <circle
            cx="44"
            cy="18"
            r="12"
            fill="#ef9a9a"
            stroke="#000"
            strokeWidth="3"
          />
          <polygon
            points="42,58 58,32 58,58"
            fill="#a5d6a7"
            stroke="#000"
            strokeWidth="3"
          />
        </svg>
      );
    case "undo":
      return (
        <svg viewBox="0 0 64 64" width="48" height="48" aria-hidden>
          <path
            d="M14 28 L26 18 L26 24 C44 24 54 34 54 48 L44 48 C44 40 38 34 26 34 L26 40 Z"
            fill="#000"
          />
        </svg>
      );
    case "redo":
      return (
        <svg viewBox="0 0 64 64" width="48" height="48" aria-hidden>
          <path
            d="M50 28 L38 18 L38 24 C20 24 10 34 10 48 L20 48 C20 40 26 34 38 34 L38 40 Z"
            fill="#000"
          />
        </svg>
      );
    case "save":
      return (
        <svg viewBox="0 0 64 64" width="48" height="48" aria-hidden>
          <rect
            x="10"
            y="10"
            width="44"
            height="44"
            fill="#1e88e5"
            stroke="#000"
            strokeWidth="3"
          />
          <rect
            x="18"
            y="10"
            width="28"
            height="16"
            fill="#fff"
            stroke="#000"
            strokeWidth="3"
          />
          <rect
            x="18"
            y="34"
            width="28"
            height="20"
            fill="#fff"
            stroke="#000"
            strokeWidth="3"
          />
          <rect x="38" y="14" width="4" height="8" fill="#000" />
        </svg>
      );
    case "clear":
      return (
        <svg viewBox="0 0 64 64" width="48" height="48" aria-hidden>
          <rect
            x="12"
            y="18"
            width="40"
            height="40"
            fill="#fff"
            stroke="#000"
            strokeWidth="3"
          />
          <path
            d="M20 26 L44 50 M44 26 L20 50"
            stroke="#e53935"
            strokeWidth="6"
            strokeLinecap="round"
          />
        </svg>
      );
    default:
      return null;
  }
}

export function ToolButton({
  label,
  icon,
  active,
  disabled,
  onClick,
}: ToolButtonProps) {
  return (
    <button
      type="button"
      className={`tool-button${active ? " is-active" : ""}`}
      disabled={disabled}
      onClick={onClick}
      aria-pressed={active}
      aria-label={label}
    >
      <span className="tool-button-icon">
        <Icon name={icon} />
      </span>
      <span className="tool-button-label">{label}</span>
    </button>
  );
}
